import { useEffect, useState } from 'react'
import './nameDialog.css'
import { FolderNode, getNodeById } from '../WooNotes/folders'
import { GUID } from '../Services/ServiceTypes'
import { WooNotesButton, WooNotesButtonSize, WooNotesButtonColor } from '../WooNotes/WooNotesButton'

type Props = {
  parentNodeId: GUID | null | undefined // null = root
  folderNodes: FolderNode[]
  onSave: (name: string) => void
  onCancel: () => void
}

export const CreateItemNodeDialog = ({ parentNodeId, folderNodes, onSave, onCancel }: Props) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue('')
  }, [parentNodeId])

  useEffect(() => {
    if (parentNodeId === undefined) return

    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel()
      if (e.key === 'Enter' && value.trim()) onSave(value)
    }

    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [parentNodeId, value, onCancel, onSave, folderNodes])

  if (parentNodeId === undefined) return null

  const parentNodeName = parentNodeId === null ? 'Root' : (getNodeById(folderNodes, parentNodeId)?.name ?? '???')

  return (
    <div className="dialog-root">
      <div className="dialog-backdrop" onClick={onCancel} />

      <div className="dialog">
        <h3>Create item in {parentNodeName}</h3>

        <input autoFocus value={value} onChange={e => setValue(e.target.value)} placeholder="Enter name" />

        <div className="actions">
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.White} onClick={() => onCancel()}>
            Cancel
          </WooNotesButton>
          <WooNotesButton size={WooNotesButtonSize.Slim} color={WooNotesButtonColor.Blue} disabled={!value.trim()} onClick={() => onSave(value)}>
            Create
          </WooNotesButton>
        </div>
      </div>
    </div>
  )
}
